import { ContractDuration, GenderOrPrenatal } from '../../../api';

export const genderNames: {
  [key in GenderOrPrenatal]: string;
} = {
  FEMALE: 'Weiblich',
  MALE: 'Männlich',
  PRENATAL: 'Vorgeburtlich',
};

export const CURRENCY_CHF = 'CHF';

export const CATEGORY = {
  HEALTH_INSURANCE: 'Krankenversicherung',
  BASIC_INSURANCE: 'Grundversicherung',
  SUPPLEMENTARY_INSURANCE: 'Zusatzversicherung',
};

export const CATEGORY_ID = {
  BASIC_INSURANCE: 'basic-insurance',
  SUPPLEMENTARY_INSURANCE: 'supplementary-insurance',
};

export function mapCustomerType(totalPersons: number): string {
  return totalPersons > 1 ? 'multiple people' : 'single person';
}

export function mapFranchise(franchise: string): string {
  return franchise.slice(franchise.indexOf('_') + 1);
}

export function mapAccidentCoverage(includesAccidentCoverage: boolean): string {
  return includesAccidentCoverage ? 'Included' : 'Not included';
}

export function mapContractLength(contractDuration: ContractDuration): string {
  switch (contractDuration) {
    case 'ONE_YEAR':
      return '1 Jahr';
    case 'THREE_YEARS':
      return '3 Jahre';
    case 'FIVE_YEARS':
      return '5 Jahre';
  }
}
